import { Copier } from '../base/copier';
import { Metamodel } from '../base/model';
import { AzureKeyVault } from './key-vault';
import { LinkedService } from './linkedservice';

type VersionKey = 'version' | 'driverVersion';
export interface IExtendedLinkedService extends LinkedService {
    driverVersion?: string;
    version?: string;
    password?: string | AzureKeyVault;
}

export class ShellLinkedServiceUtils {
    public static updateLSv2Properties(ls: IExtendedLinkedService, versionKey: VersionKey = 'version'): void {
        ls[versionKey] = 'v2';
        ls.isLegacyConnector = false;
    }

    public static commonV1ToV2(context: { inlineDataset?: boolean }, v1: IExtendedLinkedService, versionKey: VersionKey = 'version'): LinkedService {
        const copies = Copier.clone(context, [v1]) as IExtendedLinkedService[];
        if (copies?.length < 1) {
            throw new Error(`commonV1ToV2: Failed to clone ${Metamodel.modelOf(v1).name}`);
        }
        ShellLinkedServiceUtils.updateLSv2Properties(copies[0], versionKey);
        if (v1.fullyByJsonEditor) {
            const model = Metamodel.modelOf(copies[0]);
            return model.create<LinkedService>();
        }
        return this.removePassword(context, copies[0]);
    }

    public static removePassword(context: { inlineDataset?: boolean }, ls: IExtendedLinkedService): LinkedService {
        if (!(ls.password instanceof AzureKeyVault)) {
            delete ls.password;
        }
        return ls;
    }
}